import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./index.css";
import "flowbite";

const app = createApp(App);

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const usertoken = window.localStorage.getItem("panelToken");
    const authUser = JSON.parse(usertoken);
    if (authUser) {
      next();
    } else {
      next({ name: "UserLogin" });
    }
  } else {
    next();
  }
});

app.config.globalProperties.$filters = {
  localNum(value) {
    if (!value) return "0";
    value = Number(value);
    return value.toLocaleString("ar-EG");
  },
  charactersLimit(value, size) {
    if (!value) return "";
    value = value.toString();
    return value.length <= size ? value : value.substr(0, size) + "...";
  },
  charactersLimitTwo(value, size) {
    if (!value) return "";
    value = value.toString();
    return value.length <= size ? value : value.substr(0, size);
  },
};

app.use(router);
app.use(store);
app.config.productionTip = false;
app.mount("#app");
